import {ProfileButton} from "widgets/profile/ui/ui/Button.tsx";
import {EditProfileNavWrapper} from "widgets/profile/ui/styles.ts";
import {HudNavItem, IconComponent} from "widgets/hud/model/routes.ts";
import {User} from "shared/ui/icons/hudIcons/user.tsx";
import {KeyPassword} from "shared/ui/icons/hudIcons/keyPassword.tsx";

type EditProfileNaviProps = {
  activeSection: 'themeSettings' | 'dictionarySettings' | 'profileInfo' | 'profilePass' | null
  setActiveSection: (newId: 'profileInfo' | 'profilePass') => void
}

const PROFILE_BUTTONS: HudNavItem[] = [
  {
    id: 'profileInfo',
    label: 'Личные данные',
    icon: User as IconComponent,
    iconActive: User as IconComponent,
    isClickable: true,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'profilePass',
    label: 'Изменение пароля',
    icon: KeyPassword as IconComponent,
    iconActive: KeyPassword as IconComponent,
    isClickable: true,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
]

export const EditProfileNav
  = ({activeSection, setActiveSection}: EditProfileNaviProps) => (
  <EditProfileNavWrapper>
    {PROFILE_BUTTONS.map((item) => (
      <ProfileButton
        isActive={item.id === activeSection}
        key={item.id}
        item={item}
        aria-label={item.label}
        onClick={() => setActiveSection(item.id as 'profileInfo' | 'profilePass')}
      />
    ))}
  </EditProfileNavWrapper>
)